import  { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import createLPSlice from './slices/createLPSlice';
import topMenuSlice from './slices/topMenuSlice';

export const store = configureStore({
    reducer:{
        auth:authReducer,
        createLp:createLPSlice,
        topMenu:topMenuSlice
    },

})